import { Component, OnInit, inject } from '@angular/core';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { ListaUsersComponent } from '../lista-users/lista-users.component';
import { CommonModule } from '@angular/common';
import { GrupoPermissoesService } from '../../api/services/grupo-permissoes.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-home-controle-acesso',
  imports: [
    BackButtonComponent,
    ListaUsersComponent,
    CommonModule
  ],
  templateUrl: './home-controle-acesso.component.html',
  styleUrl: './home-controle-acesso.component.scss'
})
export class HomeControleAcessoComponent implements OnInit {
  grupoPermissoesService = inject(GrupoPermissoesService);
  messageService = inject(MessageService);
  totalRecords: number = 0;

  ngOnInit(): void {

  }

  onTotalRecordsChange(total: number): void {
    this.totalRecords = total;
  }
}
